import dayjs from 'dayjs';
import React, { useEffect } from 'react';

export const I18nDisabled = ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    dayjs.locale('en-gb');
  }, []);

  return <>{children}</>;
};
